var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagArg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_587",
    "data-name": "Ret\\xE2ngulo 587",
    width: 60,
    height: 60,
    transform: "translate(2631 3187)",
    fill: "#fff",
    opacity: 0.41
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_525",
    "data-name": "Ret\\xE2ngulo 525",
    width: 102.831,
    height: 59.981,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag_ARG",
    transform: "translate(-2631 -3187)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag_argentina",
    transform: "translate(2609.892 3187)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_522",
    "data-name": "Ret\\xE2ngulo 522",
    width: 102.831,
    height: 19.997,
    transform: "translate(0 19.994)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_523",
    "data-name": "Ret\\xE2ngulo 523",
    width: 102.831,
    height: 19.994,
    transform: "translate(0)",
    fill: "#80a7d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_524",
    "data-name": "Ret\\xE2ngulo 524",
    width: 102.831,
    height: 19.99,
    transform: "translate(0 39.991)",
    fill: "#80a7d8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_832",
    "data-name": "Grupo 832",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_831",
    "data-name": "Grupo 831",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8073",
    "data-name": "Caminho 8073",
    d: "M711.4,17.49l.312,8.187s0,.151.1.151.1-.151.1-.151l.311-8.187Z",
    transform: "translate(-660.394 12.493)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8074",
    "data-name": "Caminho 8074",
    d: "M711.822,25.853c-.1,0-.125-.12-.125-.177l-.312-8.177.055-.01.3,8.187s0,.125.084.125.072-.125.072-.125l.31-8.187-.25,8.187c0,.057-.036.177-.132.177",
    transform: "translate(-660.404 12.492)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8075",
    "data-name": "Caminho 8075",
    d: "M711.521,17.49l.2,5.623.2-5.623Z",
    transform: "translate(-660.307 12.493)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8076",
    "data-name": "Caminho 8076",
    d: "M711.624,19.034c-.467,1.03-.079,1.87-.534,2.769a3.481,3.481,0,0,0-.209,2.052c-.036.413-.365.53-.287.626s.443-.093.575-.646-.187-.862.367-1.963.125-1.6.693-2.585Z",
    transform: "translate(-660.977 13.596)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8077",
    "data-name": "Caminho 8077",
    d: "M710.695,24.528l-.113-.029c-.042-.06,0-.12.065-.187a.689.689,0,0,0,.208-.459,1.938,1.938,0,0,0-.017-.4,2.609,2.609,0,0,1,.239-1.658,2.964,2.964,0,0,0,.257-1.325,3.394,3.394,0,0,1,.281-1.442l.043.017a3.436,3.436,0,0,0-.269,1.428,3.146,3.146,0,0,1-.264,1.341,2.634,2.634,0,0,0-.233,1.639c.012.156.024.288.024.4a.832.832,0,0,1-.233.489c-.06.069-.077.093-.06.118.2-.026.438-.223.538-.634a1.6,1.6,0,0,0,.031-.507,2.44,2.44,0,0,1,.341-1.461,2.958,2.958,0,0,0,.334-1.32,2.569,2.569,0,0,1,.348-1.269,3.189,3.189,0,0,0-.3,1.269,3.112,3.112,0,0,1-.334,1.341,2.625,2.625,0,0,0-.348,1.433,1.809,1.809,0,0,1-.029.533.894.894,0,0,1-.492.675Z",
    transform: "translate(-660.99 13.592)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8078",
    "data-name": "Caminho 8078",
    d: "M711.469,19.186c-.37,1.027.012,1.7-.479,2.577.544-.626.186-1.428.651-2.489Z",
    transform: "translate(-660.685 13.704)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8079",
    "data-name": "Caminho 8079",
    d: "M712.219,20.958l-.312-8.174s0-.149-.094-.149-.1.149-.1.149l-.311,8.174Z",
    transform: "translate(-660.394 9.025)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8080",
    "data-name": "Caminho 8080",
    d: "M712.182,20.98,711.87,12.8s0-.132-.07-.132-.083.129-.083.129l-.3,8.181.257-8.181c0-.065.024-.183.127-.183s.131.118.131.183l.312,8.172Z",
    transform: "translate(-660.381 9.011)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8081",
    "data-name": "Caminho 8081",
    d: "M711.922,19.824l-.2-5.6-.2,5.6Z",
    transform: "translate(-660.307 10.157)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8082",
    "data-name": "Caminho 8082",
    d: "M712.339,18.226c.466-1.023.065-1.863.534-2.765a3.452,3.452,0,0,0,.2-2.049c.036-.411.377-.528.288-.626s-.431.1-.575.639.2.866-.372,1.97-.108,1.594-.676,2.582Z",
    transform: "translate(-660.15 9.117)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8083",
    "data-name": "Caminho 8083",
    d: "M712.354,18.247l-.041-.019a3.725,3.725,0,0,0,.262-1.421,2.93,2.93,0,0,1,.269-1.349,2.6,2.6,0,0,0,.221-1.63c0-.159-.024-.3-.012-.406a.77.77,0,0,1,.224-.492c.064-.072.077-.1.064-.117-.2.015-.43.216-.533.629a1.375,1.375,0,0,0-.029.511,2.522,2.522,0,0,1-.348,1.461,3.062,3.062,0,0,0-.334,1.325A2.556,2.556,0,0,1,711.755,18a3.188,3.188,0,0,0,.288-1.265,3.058,3.058,0,0,1,.341-1.341,2.359,2.359,0,0,0,.334-1.437,1.925,1.925,0,0,1,.036-.518c.108-.442.353-.651.5-.682l.012,0,.113.033c.053.053,0,.113-.06.178a.729.729,0,0,0-.216.459,1.94,1.94,0,0,0,.019.4,2.7,2.7,0,0,1-.233,1.661,2.911,2.911,0,0,0-.264,1.325,3.5,3.5,0,0,1-.269,1.44",
    transform: "translate(-660.139 9.108)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8084",
    "data-name": "Caminho 8084",
    d: "M712.09,16.869c.377-1.02-.024-1.7.478-2.57-.543.622-.2,1.425-.664,2.481Z",
    transform: "translate(-660.032 10.214)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8085",
    "data-name": "Caminho 8085",
    d: "M715.114,17.254l-8.181.3s-.156,0-.156.1.156.11.156.11l8.181.305Z",
    transform: "translate(-663.695 12.324)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8086",
    "data-name": "Caminho 8086",
    d: "M715.126,18.059l-8.188-.261c-.053,0-.172-.024-.172-.132,0-.093.119-.118.172-.118l8.183-.309.005.05-8.188.305s-.13,0-.13.072.13.084.13.084Z",
    transform: "translate(-663.703 12.314)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8087",
    "data-name": "Caminho 8087",
    d: "M713.979,17.373l-5.615.2,5.615.209Z",
    transform: "translate(-662.561 12.409)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8088",
    "data-name": "Caminho 8088",
    d: "M712.375,17.477c-1.023-.473-1.867-.072-2.758-.538a3.669,3.669,0,0,0-2.065-.2c-.407-.036-.52-.374-.623-.285s.1.434.646.573.862-.187,1.963.374,1.6.12,2.592.684Z",
    transform: "translate(-663.602 11.739)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8089",
    "data-name": "Caminho 8089",
    d: "M712.15,18.067a3.5,3.5,0,0,0-1.269-.293,3.092,3.092,0,0,1-1.348-.341,2.445,2.445,0,0,0-1.429-.341,1.538,1.538,0,0,1-.521-.033c-.412-.1-.646-.327-.683-.492l0-.017.029-.108c.072-.057.126,0,.191.06a.67.67,0,0,0,.456.218,2.062,2.062,0,0,0,.388-.026,2.747,2.747,0,0,1,1.677.233,2.82,2.82,0,0,0,1.321.266,3.454,3.454,0,0,1,1.437.269l-.012.051a3.521,3.521,0,0,0-1.425-.269,2.915,2.915,0,0,1-1.353-.269,2.617,2.617,0,0,0-1.633-.228,2.069,2.069,0,0,1-.412.021.73.73,0,0,1-.48-.23c-.065-.053-.1-.075-.121-.053.024.2.211.422.635.526a1.874,1.874,0,0,0,.509.033,2.47,2.47,0,0,1,1.454.345,3.062,3.062,0,0,0,1.323.338,2.66,2.66,0,0,1,1.269.341",
    transform: "translate(-663.61 11.727)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8090",
    "data-name": "Caminho 8090",
    d: "M711.022,17.31c-1.023-.358-1.7.024-2.58-.466.623.547,1.437.185,2.491.66Z",
    transform: "translate(-662.506 12.031)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8091",
    "data-name": "Caminho 8091",
    d: "M711.64,18.073l8.18-.305s.15,0,.15-.111-.15-.1-.15-.1l-8.18-.3Z",
    transform: "translate(-660.222 12.324)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8092",
    "data-name": "Caminho 8092",
    d: "M711.646,18.093l-.005-.053,8.18-.309s.125,0,.125-.084-.125-.072-.125-.072l-8.18-.305,8.18.257c.053,0,.167.027.167.12,0,.108-.113.132-.167.132Z",
    transform: "translate(-660.222 12.336)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8093",
    "data-name": "Caminho 8093",
    d: "M711.64,17.782l5.613-.209-5.613-.2Z",
    transform: "translate(-660.222 12.409)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8094",
    "data-name": "Caminho 8094",
    d: "M713.179,18.194c1.035.47,1.879.065,2.777.538a3.6,3.6,0,0,0,2.046.209c.407.031.52.365.623.279s-.1-.437-.646-.576-.867.2-1.957-.37c-1.108-.566-1.61-.113-2.586-.682Z",
    transform: "translate(-659.122 12.566)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8095",
    "data-name": "Caminho 8095",
    d: "M718.595,19.253a.225.225,0,0,1-.132-.077.709.709,0,0,0-.455-.216,1.79,1.79,0,0,0-.4.024,2.68,2.68,0,0,1-1.658-.24,2.933,2.933,0,0,0-1.333-.266,3.426,3.426,0,0,1-1.444-.273l.024-.045a3.473,3.473,0,0,0,1.42.269,3.071,3.071,0,0,1,1.358.269,2.586,2.586,0,0,0,1.621.231,2.318,2.318,0,0,1,.413-.022.787.787,0,0,1,.485.225c.078.067.1.072.113.063-.012-.2-.209-.425-.622-.526a1.637,1.637,0,0,0-.509-.039,2.409,2.409,0,0,1-1.46-.341,3.042,3.042,0,0,0-1.316-.334,2.66,2.66,0,0,1-1.269-.351,3.226,3.226,0,0,0,1.269.3,3.192,3.192,0,0,1,1.34.348,2.4,2.4,0,0,0,1.437.331,1.721,1.721,0,0,1,.521.036.9.9,0,0,1,.675.494v.015l-.036.108c0,.017-.017.021-.041.021",
    transform: "translate(-659.127 12.574)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8096",
    "data-name": "Caminho 8096",
    d: "M713.33,17.944c1.028.37,1.71-.012,2.584.473-.624-.542-1.431-.183-2.491-.658Z",
    transform: "translate(-659.015 12.685)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8097",
    "data-name": "Caminho 8097",
    d: "M713.811,17.324l-5.566,6s-.1.108-.029.183.174-.043.174-.043l6-5.565Z",
    transform: "translate(-662.685 12.374)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8098",
    "data-name": "Caminho 8098",
    d: "M708.273,23.565a.157.157,0,0,1-.041-.254l5.564-6,.043.033-5.566,6c-.012,0-.089.093-.041.142s.154-.036.154-.036l6-5.559-5.966,5.6a.251.251,0,0,1-.144.072",
    transform: "translate(-662.69 12.368)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8099",
    "data-name": "Caminho 8099",
    d: "M713.144,17.408l-3.818,4.114,4.118-3.825Z",
    transform: "translate(-661.875 12.434)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8100",
    "data-name": "Caminho 8100",
    d: "M712.134,18.264c-1.064.393-1.376,1.279-2.328,1.577a3.556,3.556,0,0,0-1.6,1.306c-.31.267-.634.11-.646.242s.377.235.868-.053c.473-.286.46-.747,1.641-1.123s1.213-1.047,2.315-1.337Z",
    transform: "translate(-663.135 13.046)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8101",
    "data-name": "Caminho 8101",
    d: "M707.849,21.551a.485.485,0,0,1-.233-.05l-.067-.1c0-.084.079-.087.168-.089a.8.8,0,0,0,.479-.173,1.38,1.38,0,0,0,.252-.295,2.738,2.738,0,0,1,1.357-1.018,2.788,2.788,0,0,0,1.12-.742,3.505,3.505,0,0,1,1.216-.826l.017.048a3.58,3.58,0,0,0-1.2.813,2.782,2.782,0,0,1-1.143.756,2.635,2.635,0,0,0-1.322,1,2.458,2.458,0,0,1-.264.3.832.832,0,0,1-.515.19c-.077,0-.12,0-.12.036a.748.748,0,0,0,.821-.072,1.687,1.687,0,0,0,.39-.343,2.5,2.5,0,0,1,1.273-.785,3.155,3.155,0,0,0,1.167-.691,2.537,2.537,0,0,1,1.148-.651,3.2,3.2,0,0,0-1.113.687,3.035,3.035,0,0,1-1.191.7,2.48,2.48,0,0,0-1.251.773,1.594,1.594,0,0,1-.395.346,1.164,1.164,0,0,1-.6.187",
    transform: "translate(-663.144 13.038)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8102",
    "data-name": "Caminho 8102",
    d: "M711.067,18.427c-.982.465-1.191,1.215-2.143,1.486.821-.058,1.131-.879,2.22-1.289Z",
    transform: "translate(-662.162 13.162)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8103",
    "data-name": "Caminho 8103",
    d: "M712.049,20.246l5.566-5.993s.106-.111.041-.185-.185.033-.185.033l-6,5.568Z",
    transform: "translate(-660.345 10.03)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8104",
    "data-name": "Caminho 8104",
    d: "M712.062,20.273l-.031-.024,5.566-6.005s.078-.093.031-.149-.144.033-.144.033L711.476,19.7l5.977-5.6c.031-.039.144-.1.209-.033s0,.173-.034.214Z",
    transform: "translate(-660.339 10.02)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8105",
    "data-name": "Caminho 8105",
    d: "M711.852,19.29l3.825-4.111L711.552,19Z",
    transform: "translate(-660.284 10.842)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8106",
    "data-name": "Caminho 8106",
    d: "M713.151,18.078c1.055-.394,1.365-1.275,2.333-1.577a3.608,3.608,0,0,0,1.6-1.3c.311-.266.635-.108.635-.24s-.366-.242-.857.051-.478.742-1.65,1.125-1.216,1.051-2.3,1.347Z",
    transform: "translate(-659.317 10.589)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8107",
    "data-name": "Caminho 8107",
    d: "M713.151,18.111l-.012-.045a3.565,3.565,0,0,0,1.191-.818,2.813,2.813,0,0,1,1.154-.763,2.58,2.58,0,0,0,1.312-.993,2.232,2.232,0,0,1,.276-.309.794.794,0,0,1,.5-.18c.089-.005.12-.012.12-.039a.74.74,0,0,0-.821.072,1.667,1.667,0,0,0-.377.336,2.623,2.623,0,0,1-1.28.8,2.965,2.965,0,0,0-1.178.686,2.577,2.577,0,0,1-1.131.651,3.031,3.031,0,0,0,1.1-.691,3.044,3.044,0,0,1,1.2-.7,2.461,2.461,0,0,0,1.239-.778,2.05,2.05,0,0,1,.4-.35.9.9,0,0,1,.824-.13l.072.11c-.012.072-.084.077-.173.087a.678.678,0,0,0-.468.165,2.473,2.473,0,0,0-.269.3,2.6,2.6,0,0,1-1.34,1.008,2.935,2.935,0,0,0-1.137.754,3.475,3.475,0,0,1-1.209.826",
    transform: "translate(-659.317 10.579)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8108",
    "data-name": "Caminho 8108",
    d: "M713.129,17.176c.987-.466,1.2-1.217,2.155-1.481-.82.053-1.144.874-2.22,1.284Z",
    transform: "translate(-659.205 11.211)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8109",
    "data-name": "Caminho 8109",
    d: "M714.391,19.668l-6-5.568s-.108-.1-.174-.033.031.185.031.185l5.564,5.993Z",
    transform: "translate(-662.687 10.03)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8110",
    "data-name": "Caminho 8110",
    d: "M713.844,20.249l-5.607-5.976c-.036-.041-.1-.141-.024-.213s.167-.009.208.031l6,5.568-.029.036-6-5.565s-.1-.084-.156-.036.03.146.041.146Z",
    transform: "translate(-662.695 10.02)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8111",
    "data-name": "Caminho 8111",
    d: "M713.443,19l-4.118-3.821,3.817,4.111Z",
    transform: "translate(-661.875 10.842)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8112",
    "data-name": "Caminho 8112",
    d: "M712.218,17.993c-.382-1.063-1.263-1.37-1.573-2.337a3.529,3.529,0,0,0-1.3-1.6c-.27-.312-.113-.631-.246-.639s-.233.379.043.861c.3.482.754.473,1.136,1.653s1.041,1.214,1.34,2.313Z",
    transform: "translate(-662.129 9.583)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8113",
    "data-name": "Caminho 8113",
    d: "M711.655,18.246a3.385,3.385,0,0,0-.688-1.111,3.03,3.03,0,0,1-.7-1.185,2.528,2.528,0,0,0-.778-1.257,1.492,1.492,0,0,1-.353-.391.9.9,0,0,1-.125-.826l.113-.079c.067.01.079.087.079.177a.829.829,0,0,0,.167.477,2.428,2.428,0,0,0,.312.269,2.626,2.626,0,0,1,1,1.341,2.955,2.955,0,0,0,.754,1.125,3.823,3.823,0,0,1,.831,1.209l-.053.019a3.389,3.389,0,0,0-.821-1.195,2.956,2.956,0,0,1-.759-1.149,2.661,2.661,0,0,0-.987-1.31,3.8,3.8,0,0,1-.31-.273.855.855,0,0,1-.18-.509c-.012-.086-.012-.122-.042-.125a.749.749,0,0,0,.066.826,1.845,1.845,0,0,0,.346.379,2.621,2.621,0,0,1,.791,1.275A3.06,3.06,0,0,0,711,17.109a2.606,2.606,0,0,1,.659,1.137",
    transform: "translate(-662.138 9.57)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8114",
    "data-name": "Caminho 8114",
    d: "M711.337,16.926c-.479-.984-1.233-1.191-1.5-2.151.06.819.892,1.14,1.292,2.223Z",
    transform: "translate(-661.511 10.554)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8115",
    "data-name": "Caminho 8115",
    d: "M711.469,17.9l6,5.566s.108.106.187.041-.043-.183-.043-.183l-5.564-6Z",
    transform: "translate(-660.344 12.374)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8116",
    "data-name": "Caminho 8116",
    d: "M717.6,23.519a.189.189,0,0,1-.132-.041l-6.008-5.559.031-.036,6.008,5.559s.089.1.142.036-.029-.144-.029-.144l-5.566-6,5.6,5.964c.048.051.1.149.036.216a.331.331,0,0,1-.077.005",
    transform: "translate(-660.351 12.381)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8117",
    "data-name": "Caminho 8117",
    d: "M711.552,17.7l4.123,3.825-3.823-4.114Z",
    transform: "translate(-660.284 12.434)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8118",
    "data-name": "Caminho 8118",
    d: "M712.408,19.01c.4,1.056,1.281,1.361,1.581,2.333a3.524,3.524,0,0,0,1.3,1.593c.282.317.113.638.246.646s.247-.374-.048-.862-.74-.478-1.118-1.647c-.389-1.186-1.06-1.222-1.348-2.314Z",
    transform: "translate(-659.673 13.399)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8119",
    "data-name": "Caminho 8119",
    d: "M715.542,23.6c-.078,0-.078-.084-.089-.173a.825.825,0,0,0-.168-.477,2.217,2.217,0,0,0-.3-.261,2.6,2.6,0,0,1-1.012-1.346,2.831,2.831,0,0,0-.752-1.128,3.708,3.708,0,0,1-.826-1.2l.048-.021a3.5,3.5,0,0,0,.819,1.191,2.859,2.859,0,0,1,.759,1.149,2.729,2.729,0,0,0,.994,1.322,1.472,1.472,0,0,1,.305.271.713.713,0,0,1,.173.5c.012.1.024.125.048.125a.7.7,0,0,0-.065-.816,1.919,1.919,0,0,0-.336-.389,2.48,2.48,0,0,1-.79-1.269,3,3,0,0,0-.7-1.179,2.569,2.569,0,0,1-.641-1.133,2.913,2.913,0,0,0,.689,1.106,3.226,3.226,0,0,1,.7,1.191,2.478,2.478,0,0,0,.773,1.248,1.755,1.755,0,0,1,.346.394.887.887,0,0,1,.132.83Z",
    transform: "translate(-659.683 13.401)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8120",
    "data-name": "Caminho 8120",
    d: "M712.572,18.983c.461.984,1.221,1.188,1.489,2.151-.06-.826-.879-1.14-1.292-2.217Z",
    transform: "translate(-659.556 13.513)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8121",
    "data-name": "Caminho 8121",
    d: "M712.609,17.4l-2.844,7.678s-.053.141.036.177.155-.1.155-.1l3.406-7.437Z",
    transform: "translate(-661.573 12.429)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8122",
    "data-name": "Caminho 8122",
    d: "M709.875,25.286c-.17-.041-.146-.156-.122-.216l2.837-7.675.048.022L709.8,25.089s-.043.122.018.149l.125-.093,3.411-7.435-3.368,7.462a.211.211,0,0,1-.106.113",
    transform: "translate(-661.581 12.425)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8123",
    "data-name": "Caminho 8123",
    d: "M712.356,17.448l-1.97,5.266,2.334-5.11Z",
    transform: "translate(-661.117 12.462)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8124",
    "data-name": "Caminho 8124",
    d: "M711.9,18.746c-.829.77-.78,1.7-1.557,2.349a3.655,3.655,0,0,0-.982,1.817c-.184.367-.537.346-.5.466s.441.077.776-.374.156-.874,1.1-1.677.712-1.426,1.608-2.121Z",
    transform: "translate(-662.205 13.39)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8125",
    "data-name": "Caminho 8125",
    d: "M709.009,23.467a.144.144,0,0,1-.042,0l-.115-.069c-.029-.072.047-.108.125-.144a.8.8,0,0,0,.379-.341,2.174,2.174,0,0,0,.13-.386,2.638,2.638,0,0,1,.855-1.437,3.117,3.117,0,0,0,.754-1.128,3.434,3.434,0,0,1,.791-1.226l.036.038a3.658,3.658,0,0,0-.79,1.2,2.862,2.862,0,0,1-.765,1.143,2.717,2.717,0,0,0-.839,1.421,2.467,2.467,0,0,1-.132.393.75.75,0,0,1-.4.358c-.078.041-.108.06-.1.087.2.058.474-.039.731-.381a1.549,1.549,0,0,0,.221-.458,2.623,2.623,0,0,1,.879-1.217,3.124,3.124,0,0,0,.822-1.094,2.625,2.625,0,0,1,.8-1.032,3.248,3.248,0,0,0-.753,1.051,3.158,3.158,0,0,1-.838,1.113,2.562,2.562,0,0,0-.862,1.195,1.768,1.768,0,0,1-.227.471.973.973,0,0,1-.665.441",
    transform: "translate(-662.217 13.381)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8126",
    "data-name": "Caminho 8126",
    d: "M711.242,18.917c-.735.8-.634,1.577-1.425,2.193.742-.365.719-1.25,1.557-2.037Z",
    transform: "translate(-661.523 13.512)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8127",
    "data-name": "Caminho 8127",
    d: "M712.17,20.861l2.859-7.675s.055-.137-.046-.177-.144.1-.144.1l-3.423,7.437Z",
    transform: "translate(-660.381 9.287)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8128",
    "data-name": "Caminho 8128",
    d: "M712.2,20.87l-.053-.015,2.842-7.675s.053-.113-.012-.144l-.12.087-3.424,7.438,3.364-7.455a.3.3,0,0,1,.113-.115l.144.057a.253.253,0,0,1-.011.153Z",
    transform: "translate(-660.371 9.279)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8129",
    "data-name": "Caminho 8129",
    d: "M711.9,19.731l1.97-5.263-2.335,5.107Z",
    transform: "translate(-660.296 10.334)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8130",
    "data-name": "Caminho 8130",
    d: "M712.843,18.2c.82-.771.778-1.7,1.557-2.349a3.512,3.512,0,0,0,.964-1.819c.2-.369.555-.341.514-.465-.06-.122-.442-.081-.778.369s-.155.873-1.1,1.675-.725,1.433-1.622,2.126Z",
    transform: "translate(-659.695 9.646)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8131",
    "data-name": "Caminho 8131",
    d: "M712.846,18.228l-.036-.036a3.406,3.406,0,0,0,.791-1.215,2.783,2.783,0,0,1,.766-1.14,2.618,2.618,0,0,0,.844-1.418,2.374,2.374,0,0,1,.132-.386.8.8,0,0,1,.395-.365c.072-.043.12-.06.108-.087a.716.716,0,0,0-.73.381,1.854,1.854,0,0,0-.241.458A2.435,2.435,0,0,1,714,15.643a3.048,3.048,0,0,0-.814,1.085,2.546,2.546,0,0,1-.8,1.034,3.5,3.5,0,0,0,.754-1.056,2.986,2.986,0,0,1,.82-1.1,2.524,2.524,0,0,0,.868-1.2,2.146,2.146,0,0,1,.233-.477c.246-.331.534-.47.713-.435l.107.074c.023.069-.042.1-.119.144a.663.663,0,0,0-.377.338,1.486,1.486,0,0,0-.132.381,2.629,2.629,0,0,1-.856,1.445A3.035,3.035,0,0,0,713.641,17a3.44,3.44,0,0,1-.8,1.229",
    transform: "translate(-659.685 9.636)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8132",
    "data-name": "Caminho 8132",
    d: "M712.7,16.987c.735-.8.634-1.581,1.425-2.2-.75.367-.726,1.245-1.569,2.04Z",
    transform: "translate(-659.571 10.565)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8133",
    "data-name": "Caminho 8133",
    d: "M715,18.467l-7.672-2.846s-.139-.06-.18.033.113.156.113.156l7.433,3.411Z",
    transform: "translate(-663.433 11.144)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8134",
    "data-name": "Caminho 8134",
    d: "M714.711,19.213l-7.451-3.369c-.06-.031-.156-.1-.125-.192a.162.162,0,0,1,.214-.045l7.674,2.842-.013.048-7.672-2.846c-.012,0-.125-.048-.155.021s.089.127.089.127Z",
    transform: "translate(-663.444 11.133)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8135",
    "data-name": "Caminho 8135",
    d: "M713.875,18.206l-5.266-1.97,5.11,2.347Z",
    transform: "translate(-662.386 11.597)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8136",
    "data-name": "Caminho 8136",
    d: "M712.342,17.754c-.767-.831-1.7-.778-2.352-1.558a3.538,3.538,0,0,0-1.813-.974c-.365-.189-.341-.542-.466-.5s-.089.441.377.778c.442.338.868.156,1.669,1.1s1.43.722,2.131,1.615Z",
    transform: "translate(-663.071 10.512)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8137",
    "data-name": "Caminho 8137",
    d: "M711.912,18.205a3.145,3.145,0,0,0-1.059-.754,3.115,3.115,0,0,1-1.108-.831,2.5,2.5,0,0,0-1.189-.862,1.749,1.749,0,0,1-.479-.23.926.926,0,0,1-.442-.715l.077-.1c.067-.029.115.036.151.12a.729.729,0,0,0,.34.377,1.925,1.925,0,0,0,.366.123,2.631,2.631,0,0,1,1.454.861,2.92,2.92,0,0,0,1.125.751,3.46,3.46,0,0,1,1.232.8l-.041.036a3.594,3.594,0,0,0-1.2-.8,2.96,2.96,0,0,1-1.155-.761,2.572,2.572,0,0,0-1.423-.84,2.943,2.943,0,0,1-.377-.129.81.81,0,0,1-.365-.4c-.036-.081-.055-.12-.091-.1-.053.194.043.478.39.732a1.853,1.853,0,0,0,.456.225,2.488,2.488,0,0,1,1.22.878,2.945,2.945,0,0,0,1.089.816,2.568,2.568,0,0,1,1.035.8",
    transform: "translate(-663.086 10.502)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8138",
    "data-name": "Caminho 8138",
    d: "M711.137,17.088c-.808-.723-1.586-.638-2.2-1.416.365.741,1.245.713,2.046,1.56Z",
    transform: "translate(-662.155 11.194)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8139",
    "data-name": "Caminho 8139",
    d: "M711.549,18.027l7.671,2.846s.132.063.18-.036-.1-.149-.1-.149l-7.445-3.415Z",
    transform: "translate(-660.287 12.338)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8140",
    "data-name": "Caminho 8140",
    d: "M719.316,20.909a.365.365,0,0,1-.1-.021l-7.673-2.842.019-.046,7.678,2.844s.106.045.142-.024-.089-.12-.089-.12l-7.438-3.415,7.462,3.37c.053.026.156.1.114.182a.119.119,0,0,1-.114.072",
    transform: "translate(-660.292 12.346)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8141",
    "data-name": "Caminho 8141",
    d: "M711.591,17.762l5.266,1.958-5.11-2.335Z",
    transform: "translate(-660.257 12.418)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8142",
    "data-name": "Caminho 8142",
    d: "M712.89,18.692c.778.828,1.71.778,2.352,1.557a3.531,3.531,0,0,0,1.813.972c.377.192.341.545.479.5.108-.041.072-.442-.384-.78s-.86-.147-1.663-1.09-1.441-.72-2.131-1.622Z",
    transform: "translate(-659.329 13.022)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8143",
    "data-name": "Caminho 8143",
    d: "M717.515,21.747c-.06,0-.089-.065-.125-.134a.77.77,0,0,0-.33-.375,2.763,2.763,0,0,0-.389-.132,2.576,2.576,0,0,1-1.437-.849,2.9,2.9,0,0,0-1.131-.751,3.543,3.543,0,0,1-1.221-.8l.029-.036a3.472,3.472,0,0,0,1.215.789,2.978,2.978,0,0,1,1.144.761,2.6,2.6,0,0,0,1.418.84,2.477,2.477,0,0,1,.384.132.794.794,0,0,1,.365.4c.042.093.053.11.089.1.053-.189-.036-.477-.382-.734a1.632,1.632,0,0,0-.468-.218,2.589,2.589,0,0,1-1.221-.878,2.865,2.865,0,0,0-1.088-.816,2.6,2.6,0,0,1-1.019-.806A3.126,3.126,0,0,0,714.4,19a3,3,0,0,1,1.1.828,2.478,2.478,0,0,0,1.2.862,1.4,1.4,0,0,1,.467.23.871.871,0,0,1,.444.715l-.065.106a.129.129,0,0,1-.031.005",
    transform: "translate(-659.334 13.029)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8144",
    "data-name": "Caminho 8144",
    d: "M713.064,18.545c.8.73,1.574.631,2.191,1.425-.372-.742-1.245-.725-2.035-1.562Z",
    transform: "translate(-659.205 13.149)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8145",
    "data-name": "Caminho 8145",
    d: "M714.695,17.273l-7.433,3.413s-.144.055-.113.151.18.036.18.036L715,18.027Z",
    transform: "translate(-663.433 12.338)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8146",
    "data-name": "Caminho 8146",
    d: "M707.261,20.928a.128.128,0,0,1-.125-.072c-.031-.086.065-.158.125-.182l7.434-3.415.017.045-7.438,3.415s-.113.053-.089.12.143.024.155.024l7.672-2.844-7.661,2.889a.275.275,0,0,1-.089.021",
    transform: "translate(-663.444 12.328)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8147",
    "data-name": "Caminho 8147",
    d: "M713.72,17.385l-5.11,2.333,5.267-1.956Z",
    transform: "translate(-662.386 12.418)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8148",
    "data-name": "Caminho 8148",
    d: "M712.307,17.669c-1.131-.041-1.753.653-2.77.562a3.537,3.537,0,0,0-1.963.593c-.4.132-.634-.144-.689-.022s.257.365.808.283.737-.506,1.958-.411,1.526-.5,2.657-.351Z",
    transform: "translate(-663.625 12.619)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8149",
    "data-name": "Caminho 8149",
    d: "M707.493,19.136a.752.752,0,0,1-.6-.213l-.031-.125c.042-.069.108-.043.2-.012a.735.735,0,0,0,.5.026,1.971,1.971,0,0,0,.373-.177,2.692,2.692,0,0,1,1.615-.422,2.83,2.83,0,0,0,1.335-.262,3.479,3.479,0,0,1,1.437-.3v.051a3.669,3.669,0,0,0-1.424.29,2.958,2.958,0,0,1-1.347.269,2.591,2.591,0,0,0-1.6.418,3.371,3.371,0,0,1-.365.175.8.8,0,0,1-.531-.024c-.1-.036-.127-.036-.132-.019.1.185.353.317.783.252a1.669,1.669,0,0,0,.479-.161,2.505,2.505,0,0,1,1.479-.247,3.03,3.03,0,0,0,1.357-.19,2.6,2.6,0,0,1,1.3-.165,3.067,3.067,0,0,0-1.287.213,3.129,3.129,0,0,1-1.37.194,2.468,2.468,0,0,0-1.456.24,1.809,1.809,0,0,1-.49.173c-.077,0-.156.012-.221.012",
    transform: "translate(-663.633 12.609)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8150",
    "data-name": "Caminho 8150",
    d: "M711,17.793c-1.089.057-1.562.674-2.568.55.791.267,1.388-.37,2.556-.334Z",
    transform: "translate(-662.511 12.709)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8151",
    "data-name": "Caminho 8151",
    d: "M711.854,19.221,719.3,15.81s.143-.057.1-.156-.18-.033-.18-.033l-7.671,2.846Z",
    transform: "translate(-660.287 11.144)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8152",
    "data-name": "Caminho 8152",
    d: "M711.864,19.259l-.017-.045,7.438-3.415s.125-.05.089-.125-.144-.021-.144-.021L711.552,18.5l7.654-2.89c.06-.027.18-.043.216.045s-.061.161-.114.19Z",
    transform: "translate(-660.285 11.134)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8153",
    "data-name": "Caminho 8153",
    d: "M711.746,18.582l5.11-2.345L711.591,18.2Z",
    transform: "translate(-660.257 11.598)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8154",
    "data-name": "Caminho 8154",
    d: "M713.239,17.916c1.12.045,1.754-.655,2.766-.559a3.532,3.532,0,0,0,1.963-.6c.4-.122.634.141.694.024s-.257-.369-.826-.286c-.55.089-.719.507-1.951.41s-1.525.5-2.645.353Z",
    transform: "translate(-659.079 11.773)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8155",
    "data-name": "Caminho 8155",
    d: "M713.334,17.954h-.1V17.9a3.479,3.479,0,0,0,1.413-.3A2.959,2.959,0,0,1,716,17.343a2.606,2.606,0,0,0,1.6-.42,2.209,2.209,0,0,1,.365-.177.787.787,0,0,1,.538.027c.083.033.12.039.12.012-.089-.177-.353-.31-.778-.254a1.462,1.462,0,0,0-.478.168,2.546,2.546,0,0,1-1.485.242,2.968,2.968,0,0,0-1.346.2,2.7,2.7,0,0,1-1.3.161,3.1,3.1,0,0,0,1.275-.214,3.246,3.246,0,0,1,1.37-.2,2.484,2.484,0,0,0,1.456-.233,1.532,1.532,0,0,1,.5-.173.872.872,0,0,1,.826.2l.017.125c-.029.067-.106.043-.2.012a.732.732,0,0,0-.5-.027,2.294,2.294,0,0,0-.353.175,2.639,2.639,0,0,1-1.634.422,2.841,2.841,0,0,0-1.321.266,3.67,3.67,0,0,1-1.335.3",
    transform: "translate(-659.081 11.762)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8156",
    "data-name": "Caminho 8156",
    d: "M713.35,17.444c1.083-.048,1.562-.663,2.549-.547-.778-.267-1.389.379-2.544.343Z",
    transform: "translate(-659 12.023)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8157",
    "data-name": "Caminho 8157",
    d: "M713.362,20.542l-3.407-7.435s-.058-.142-.154-.1-.036.175-.036.175l2.842,7.677Z",
    transform: "translate(-661.573 9.286)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8158",
    "data-name": "Caminho 8158",
    d: "M712.64,20.855,709.755,13.2a.246.246,0,0,1-.012-.149l.132-.06a.2.2,0,0,1,.108.113l3.411,7.437-.042.021-3.477-7.546-.06.021-.018.144Z",
    transform: "translate(-661.582 9.28)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8159",
    "data-name": "Caminho 8159",
    d: "M712.72,19.575l-2.333-5.107,1.968,5.263Z",
    transform: "translate(-661.117 10.335)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8160",
    "data-name": "Caminho 8160",
    d: "M712.068,18.16c.041-1.135-.653-1.757-.569-2.765a3.562,3.562,0,0,0-.6-1.975c-.12-.394.144-.622.036-.682-.125-.053-.377.254-.286.811s.507.725.406,1.959.5,1.521.358,2.649Z",
    transform: "translate(-660.943 9.094)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8161",
    "data-name": "Caminho 8161",
    d: "M712.1,18.167h-.053a3.644,3.644,0,0,0-.295-1.416,2.967,2.967,0,0,1-.274-1.353,2.593,2.593,0,0,0-.413-1.594,3.259,3.259,0,0,1-.18-.362.857.857,0,0,1,.036-.542c.024-.087.036-.12.012-.132-.19.1-.311.362-.257.782a2.232,2.232,0,0,0,.167.487,2.5,2.5,0,0,1,.246,1.478,3.138,3.138,0,0,0,.192,1.351,2.63,2.63,0,0,1,.161,1.3,3.266,3.266,0,0,0-.209-1.284,3.118,3.118,0,0,1-.2-1.366,2.44,2.44,0,0,0-.235-1.455,1.611,1.611,0,0,1-.166-.494.885.885,0,0,1,.185-.816l.138-.027c.066.033.042.108.012.2a.716.716,0,0,0-.036.5,3,3,0,0,0,.179.358,2.706,2.706,0,0,1,.419,1.625,2.866,2.866,0,0,0,.269,1.332,3.593,3.593,0,0,1,.3,1.43",
    transform: "translate(-660.952 9.086)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8162",
    "data-name": "Caminho 8162",
    d: "M711.6,16.852c-.054-1.089-.665-1.569-.557-2.558-.262.78.377,1.39.348,2.549Z",
    transform: "translate(-660.694 10.21)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8163",
    "data-name": "Caminho 8163",
    d: "M711.417,17.718l3.422,7.438s.053.141.142.1.048-.177.048-.177l-2.86-7.678Z",
    transform: "translate(-660.381 12.429)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8164",
    "data-name": "Caminho 8164",
    d: "M715.005,25.277a.285.285,0,0,1-.192-.113L711.4,17.722l.05-.021,3.421,7.435s.055.125.121.093.012-.146.012-.149l-2.842-7.671,2.9,7.653c.024.06.048.175-.053.216",
    transform: "translate(-660.392 12.434)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8165",
    "data-name": "Caminho 8165",
    d: "M711.535,17.6l2.333,5.11L711.9,17.447Z",
    transform: "translate(-660.297 12.462)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8166",
    "data-name": "Caminho 8166",
    d: "M711.815,19.088c-.048,1.131.653,1.757.562,2.769a3.767,3.767,0,0,0,.586,1.977c.139.393-.144.622-.017.681s.365-.261.286-.818-.508-.722-.413-1.958-.5-1.519-.352-2.642Z",
    transform: "translate(-660.099 13.634)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8167",
    "data-name": "Caminho 8167",
    d: "M712.949,24.54c-.077-.036-.041-.117-.012-.194a.742.742,0,0,0,.024-.509,2.237,2.237,0,0,0-.18-.365,2.8,2.8,0,0,1-.425-1.622,2.862,2.862,0,0,0-.25-1.325,3.52,3.52,0,0,1-.312-1.437l.055,0a3.526,3.526,0,0,0,.3,1.414,2.865,2.865,0,0,1,.27,1.349,2.664,2.664,0,0,0,.408,1.6,1.523,1.523,0,0,1,.178.369.759.759,0,0,1-.022.538c-.031.084-.031.115-.007.132a.737.737,0,0,0,.246-.792,1.459,1.459,0,0,0-.167-.482,2.619,2.619,0,0,1-.234-1.479,3.061,3.061,0,0,0-.2-1.349,2.668,2.668,0,0,1-.163-1.3,3.23,3.23,0,0,0,.216,1.282,3.09,3.09,0,0,1,.192,1.368,2.534,2.534,0,0,0,.233,1.457,1.8,1.8,0,0,1,.18.5.934.934,0,0,1-.2.816Z",
    transform: "translate(-660.113 13.635)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8168",
    "data-name": "Caminho 8168",
    d: "M711.94,19.2c.06,1.087.67,1.569.55,2.558.264-.787-.37-1.39-.334-2.542Z",
    transform: "translate(-660.008 13.716)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8169",
    "data-name": "Caminho 8169",
    d: "M713.031,15.55a3.33,3.33,0,1,1-3.339,3.324,3.322,3.322,0,0,1,3.339-3.324",
    transform: "translate(-661.613 11.107)",
    fill: "#f1bd51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8170",
    "data-name": "Caminho 8170",
    d: "M713.038,22.249a3.357,3.357,0,1,1,3.364-3.363,3.358,3.358,0,0,1-3.364,3.363m0-6.663a3.308,3.308,0,1,0,3.3,3.3,3.316,3.316,0,0,0-3.3-3.3",
    transform: "translate(-661.621 11.096)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8171",
    "data-name": "Caminho 8171",
    d: "M713.706,17.32a1.336,1.336,0,0,0-1.753-.2,1.07,1.07,0,0,0,.089,1.354.277.277,0,0,0-.113.043,1.772,1.772,0,0,1-.132-1.454,1.242,1.242,0,0,1,1.91.254",
    transform: "translate(-660.181 11.95)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8172",
    "data-name": "Caminho 8172",
    d: "M712.682,16.983a.684.684,0,0,0-.569.206c-.154.132-.233.1-.262.132s0,.1.053.075a1.548,1.548,0,0,0,.312-.207.649.649,0,0,1,.467-.125c.454,0,.711.382.767.358s-.265-.439-.767-.439",
    transform: "translate(-660.078 12.131)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8173",
    "data-name": "Caminho 8173",
    d: "M713.165,17.355a.765.765,0,0,0-1.2.024h.1c.257-.41.88-.237.922-.051v.051Z",
    transform: "translate(-659.988 12.199)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8174",
    "data-name": "Caminho 8174",
    d: "M712.4,17.088a.242.242,0,0,1,.233.233.239.239,0,0,1-.233.23.235.235,0,0,1-.233-.23.238.238,0,0,1,.233-.233",
    transform: "translate(-659.848 12.206)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8175",
    "data-name": "Caminho 8175",
    d: "M711.968,17.275a1.033,1.033,0,0,0,1.2-.024l-.173-.027a.68.68,0,0,1-.922.051v-.051Z",
    transform: "translate(-659.988 12.303)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8176",
    "data-name": "Caminho 8176",
    d: "M713.255,17.333a1.022,1.022,0,0,1-1.132.156c-.257-.156-.257-.2-.2-.2s.1.048.312.151a1.3,1.3,0,0,0,1.023-.1",
    transform: "translate(-660.042 12.346)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8177",
    "data-name": "Caminho 8177",
    d: "M712.2,17.765a.15.15,0,0,1-.1.285.154.154,0,0,1-.114-.135.384.384,0,0,1-.329.2h-.047l.047.077a.537.537,0,0,0,.306-.077.236.236,0,0,0,.322.063.232.232,0,0,0,.055-.329.182.182,0,0,0-.144-.087",
    transform: "translate(-660.242 12.689)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8178",
    "data-name": "Caminho 8178",
    d: "M712.5,18.547c-.222-.153-.329-.382-.586-.382a.583.583,0,0,0-.252.081h-.047l.047.072c.1,0,.252-.127.444-.024.173.1.274.2.395.254",
    transform: "translate(-660.243 12.975)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8179",
    "data-name": "Caminho 8179",
    d: "M712.431,18.423a1.381,1.381,0,0,0-.771-.051h-.047l.047.108c.2,0,.306-.156.771-.057",
    transform: "translate(-660.242 13.099)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8180",
    "data-name": "Caminho 8180",
    d: "M712.5,18.39c-.551-.051-.377.285-.839.285h-.047l.047.077c.565,0,.305-.305.839-.362",
    transform: "translate(-660.243 13.132)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8181",
    "data-name": "Caminho 8181",
    d: "M712.3,19.058a.462.462,0,0,0-.461-.458.467.467,0,0,0-.466.458.471.471,0,0,1,.574-.345.458.458,0,0,1,.354.345",
    transform: "translate(-660.416 13.286)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8182",
    "data-name": "Caminho 8182",
    d: "M710.411,17.32a1.327,1.327,0,0,1,1.747-.2,1.081,1.081,0,0,1-.077,1.354.293.293,0,0,1,.1.043,1.741,1.741,0,0,0,.132-1.454,1.235,1.235,0,0,0-1.9.254",
    transform: "translate(-661.1 11.95)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8183",
    "data-name": "Caminho 8183",
    d: "M711.276,16.983a.7.7,0,0,1,.562.206c.149.132.221.1.257.132s0,.1-.053.075a1.736,1.736,0,0,1-.312-.207.634.634,0,0,0-.454-.125c-.461,0-.712.382-.771.358s.257-.439.771-.439",
    transform: "translate(-661.037 12.131)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8184",
    "data-name": "Caminho 8184",
    d: "M710.606,17.355a.777.777,0,0,1,1.208.024h-.108c-.257-.41-.867-.237-.908-.051v.051Z",
    transform: "translate(-660.96 12.199)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8185",
    "data-name": "Caminho 8185",
    d: "M711.081,17.088a.233.233,0,0,0-.233.233.227.227,0,1,0,.233-.233",
    transform: "translate(-660.788 12.206)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8186",
    "data-name": "Caminho 8186",
    d: "M711.815,17.275a1.051,1.051,0,0,1-1.208-.024l.19-.027a.664.664,0,0,0,.91.051v-.051Z",
    transform: "translate(-660.96 12.303)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8187",
    "data-name": "Caminho 8187",
    d: "M710.589,17.333a1.023,1.023,0,0,0,1.132.156c.257-.156.257-.2.2-.2s-.094.048-.3.151a1.316,1.316,0,0,1-1.029-.1",
    transform: "translate(-660.972 12.346)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8188",
    "data-name": "Caminho 8188",
    d: "M711.406,17.765a.139.139,0,0,0-.083.192.136.136,0,0,0,.185.093.15.15,0,0,0,.1-.135.386.386,0,0,0,.333.2H712l-.055.077a.557.557,0,0,1-.31-.077.226.226,0,0,1-.312.063.243.243,0,0,1-.072-.329.254.254,0,0,1,.156-.087",
    transform: "translate(-660.526 12.689)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8189",
    "data-name": "Caminho 8189",
    d: "M711.144,18.547c.233-.153.336-.382.593-.382a.632.632,0,0,1,.257.081h.053l-.053.072c-.1,0-.257-.127-.437-.024s-.288.2-.413.254",
    transform: "translate(-660.576 12.975)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8190",
    "data-name": "Caminho 8190",
    d: "M711.19,18.423a1.38,1.38,0,0,1,.77-.051h.057l-.057.108c-.2,0-.311-.156-.77-.057",
    transform: "translate(-660.543 13.099)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8191",
    "data-name": "Caminho 8191",
    d: "M711.144,18.39c.569-.051.382.285.85.285h.053l-.053.077c-.562,0-.312-.305-.85-.362",
    transform: "translate(-660.576 13.132)",
    fill: "#7a361d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8192",
    "data-name": "Caminho 8192",
    d: "M711.367,19.058a.467.467,0,0,1,.466-.458.462.462,0,0,1,.461.458.464.464,0,0,0-.574-.345.479.479,0,0,0-.354.345",
    transform: "translate(-660.416 13.286)",
    fill: "#7a361d"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagArg);
export default __webpack_public_path__ + "static/media/flag_ARG.f9a15f95d4cd46dedc1c1718fa428041.svg";
export { ForwardRef as ReactComponent };